import {
  DropdownMenu as DropdownMenuPrimitive,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "@radix-ui/react-dropdown-menu";

import { DropdownMenuContent } from "@radix-ui/react-dropdown-menu";
import { ChevronDown } from "lucide-react";
import { useRef, useState } from "react";

export type DropdownMenuProps = {
  className?: string;
  placeholder: string;
  index: number | null;
  data: {
    label: string;
    value: string;
  }[];
  onSelectChange: (value: string) => void;
};

export const DropdownMenu = ({
  className,
  placeholder,
  index,
  data,
  onSelectChange,
}: DropdownMenuProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(index);
  const ref = useRef<HTMLDivElement>(null);
  const handleSelectChange = (value: string) => {
    setSelectedIndex(data.findIndex((item) => item.value === value));
    onSelectChange(value);
  };

  return (
    <DropdownMenuPrimitive>
      <DropdownMenuTrigger asChild>
        <div
          ref={ref}
          className={`flex items-center w-full justify-between gap-4 px-4 py-3 border border-gray-300 hover:border-brand-300 rounded-xl hover:ring-4 hover:ring-brand-300/25 cursor-pointer ${className}`}
        >
          <span>
            {selectedIndex === null || !data[selectedIndex]
              ? placeholder
              : data[selectedIndex].label}
          </span>
          <ChevronDown className="w-4 h-4" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="rounded-xl border border-gray-200 p-1 bg-white z-50"
        style={{ minWidth: ref.current?.clientWidth }}
      >
        {data.map((item, index) => (
          <DropdownMenuItem
            key={index}
            onClick={() => handleSelectChange(item.value)}
            className="cursor-pointer hover:bg-gray-100 rounded-xl py-1 px-2 outline-none"
          >
            <span>{item.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuPrimitive>
  );
};
